import * as types from '../actions/types';

const initialState = {
  academicPeriod: '',
  control: '',
  cathedra: [],
  group: '',
  discipline: '',
  testResult: '',
  academicPeriodLoading: false,
  testResultPhotos: [],
  faculty: []
};

export default function management(state = initialState, action) {
  switch (action.type) {
    case types.ACADEMIC_YEAR_FETCHED:
      return {
        ...state,
        academicYear: action.academicYear.schoolYear,
      };
    case types.ACADEMIC_PERIOD_FETCH_START:
      return {
        ...state,
        academicPeriodLoading: true,
      };
    case types.ACADEMIC_PERIOD_FETCH_END:
      return {
        ...state,
        academicPeriod: action.academicPeriod.terms || [],
        academicPeriodLoading: false,
      };
    /* eslint-disable */
    case types.FACULTY_FETCHED:
      const allFaculty = { faculty: 'Все', idfaculty: 0 };
      const faculty = action.check ? [allFaculty, ...action.faculty] : action.faculty;
      return {
        ...state,
        faculty,
      };
    case types.CATHEDRA_FETCHED:
      const allCathedra = { cathedra: 'Все', idcathedra: 0 };
      const cathedra = action.check ? [allCathedra, ...action.cathedra] : action.cathedra;
      return {
        ...state,
        cathedra,
      };
    /* eslint-enable */
    case types.GROUP_FETCHED:
      return {
        ...state,
        group: action.group,
      };
    case types.SET_GROUPS_BY_COURSE:
      return {
        ...state,
        group: action.payload,
      };
    case types.DISCIPLINE_FETCHED:
      return {
        ...state,
        discipline: action.discipline,
      };
    case types.CONTROL_FETCHED:
      return {
        ...state,
        control: action.control,
      };
    case types.TEST_RESULT_FETCHED:
      return {
        ...state,
        testResult: action.testResult,
      };
    case types.CLEAR_TEST_RESULTS:
      return {
        ...state,
        testResult: '',
      };
    case types.RESET_DOCUMENTS:
      return {
        ...state,
        testResultPhotos: [],
      };
    // eslint-disable-next-line
    case types.TEST_RESULT_PHOTO_FETCHED:
      const photos = [...state.testResultPhotos];
      photos[action.idx] = { photo: action.testResultPhoto };
      return {
        ...state,
        testResultPhotos: photos,
      };
    default:
      return state;
  }
}
